import { cn } from "cn";
import { isEmpty } from "lodash-es";
import {
  BwCheckCircleFill,
  BwCheckCircleLine,
  BwDashCircleLine,
  BwFolderFileImageLine,
  BwUpdateLeftLine,
} from "@/components/ui/icons";
import { ListItemStatus } from "@/types/openapi-enum";

export enum IconType {
  Line = "line",
  Fill = "fill",
}

// The status words live in STATUS_LABELS (features/shared/list-item-fields); this is the icon only.
const getStatusSpecs = (status: ListItemStatus, type = IconType.Line) => {
  switch (status) {
    case ListItemStatus.InProgress:
      return { iconColor: "text-text-primary", Icon: BwUpdateLeftLine };
    case ListItemStatus.Done:
      return {
        iconColor: "text-text-success",
        Icon: type === IconType.Line ? BwCheckCircleLine : BwCheckCircleFill,
      };
    case ListItemStatus.Archived:
      return { iconColor: "text-text-dark-max", Icon: BwFolderFileImageLine };
    // To do, and a value this build does not know.
    default:
      return { iconColor: "text-text-fuchsia", Icon: BwDashCircleLine };
  }
};

export function ListItemStatusIcon({
  status,
  type = IconType.Line,
  size = 16,
}: {
  status: ListItemStatus;
  type?: IconType;
  size?: number;
}) {
  if (isEmpty(status)) {
    return null;
  }
  const { iconColor, Icon } = getStatusSpecs(status, type);
  return <Icon size={size} className={cn(iconColor, "shrink-0")} />;
}
